import React from 'react';
import { FaCheck } from 'react-icons/fa';

function WhyWorkWithMe({ benefits }) {
  return (
    <section className="portfolioSection sectionReveal" id="why-work-with-me">
      <div className="portfolioWhy">
        <div className="portfolioSection__heading">
          <span className="portfolioEyebrow">Why Work With Me</span>
          <h2>Reliable development from idea to launch.</h2>
          <p>
            I focus on practical engineering, maintainable systems, and clear collaboration so your software is useful after it ships.
          </p>
        </div>

        <div className="portfolioWhy__grid">
          {benefits.map((benefit) => (
            <div className="portfolioWhy__item" key={benefit}>
              <FaCheck />
              <span>{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyWorkWithMe;
